import { render, staticRenderFns } from "./BurnLiquidityModal.vue?vue&type=template&id=899093e6&scoped=true&"
import script from "./BurnLiquidityModal.vue?vue&type=script&lang=js&"
export * from "./BurnLiquidityModal.vue?vue&type=script&lang=js&"
import style0 from "./BurnLiquidityModal.vue?vue&type=style&index=0&id=899093e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899093e6",
  null
  
)

export default component.exports